<template>
  <v-row justify="center">
    <v-dialog v-model="dialogInterno" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ step === "form" ? "Solicitar Pagamento" : "Confirmação" }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Step 1: Formulário de mês e ano -->
        <template v-if="step === 'form'">
          <v-card-text>
            <v-form ref="form">
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-select
                      v-model="mes"
                      :items="meses"
                      item-text="text"
                      item-value="value"
                      label="Mês"
                      outlined
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="ano"
                      :items="anos"
                      label="Ano"
                      outlined
                      :rules="[rules.required]"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="close">Cancelar</v-btn>
            <v-btn color="primary" dark @click="confirmar">
              Continuar
            </v-btn>
          </v-card-actions>
        </template>

        <!-- Step 2: Confirmação -->
        <template v-if="step === 'confirm'">
          <v-card-text>
            <v-container>
              <v-alert type="warning" outlined prominent>
                <div class="text-subtitle-1 font-weight-bold mb-2">
                  Atenção!
                </div>
                <div>
                  Você está prestes a solicitar o pagamento das campanhas
                  referentes a <strong>{{ mesTexto }}/{{ ano }}</strong
                  >.
                </div>
                <div class="mt-2">
                  Deseja realmente prosseguir com esta ação?
                </div>
              </v-alert>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="step = 'form'">
              Voltar
            </v-btn>
            <v-btn
              color="success"
              dark
              :loading="loading"
              @click="enviarSolicitacao"
            >
              <v-icon left>mdi-check</v-icon>
              Confirmar Envio
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import http from "@/services/http";

export default {
  name: "ModalSolicitarPagamento",

  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();

    return {
      step: "form",
      loading: false,
      mes: currentMonth,
      ano: currentYear,
      meses: [
        { text: "Janeiro", value: 1 },
        { text: "Fevereiro", value: 2 },
        { text: "Março", value: 3 },
        { text: "Abril", value: 4 },
        { text: "Maio", value: 5 },
        { text: "Junho", value: 6 },
        { text: "Julho", value: 7 },
        { text: "Agosto", value: 8 },
        { text: "Setembro", value: 9 },
        { text: "Outubro", value: 10 },
        { text: "Novembro", value: 11 },
        { text: "Dezembro", value: 12 }
      ],
      rules: {
        required: v => !!v || "Campo obrigatório"
      }
    };
  },

  computed: {
    dialogInterno: {
      get() {
        return this.dialog;
      },
      set(val) {
        if (!val) this.close();
      }
    },

    anos() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear - 2; i <= currentYear + 1; i++) {
        years.push(i);
      }
      return years;
    },

    mesTexto() {
      const found = this.meses.find(m => m.value === this.mes);
      return found ? found.text : "";
    }
  },

  methods: {
    close() {
      this.step = "form";
      this.loading = false;
      this.$emit("close");
    },

    confirmar() {
      if (this.$refs.form.validate()) {
        this.step = "confirm";
      }
    },

    async enviarSolicitacao() {
      this.loading = true;
      try {
        await http.post("/campanhas/solicitar-pagamento", {
          mes: this.mes,
          ano: this.ano
        });

        this.$notify({
          text: `Solicitação de pagamento para ${this.mesTexto}/${this.ano} enviada com sucesso!`,
          type: "success"
        });

        this.close();
        this.$emit("solicitado");
      } catch (error) {
        const mensagem =
          error?.response?.data?.message ||
          "Erro ao solicitar pagamento das campanhas.";

        this.$notify({
          text: mensagem,
          type: "error"
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
